import { createActionNameForProcessingFetch } from '../../utils/helpers/actionCreatorHelpers';
import { PHASES_DOMAIN_NAME } from './constants';

export const getPhaseConfigConstants = createActionNameForProcessingFetch('getPhaseConfig', PHASES_DOMAIN_NAME);
export const updatePhaseConfigConstants = createActionNameForProcessingFetch('updatePhaseConfig', PHASES_DOMAIN_NAME);
